import Pqp from "../../../3x1010/Pqp.js";
import MazeConst from "../MazeConst.js";

export default class RoomDesign {
	constructor(initer) {
		this.initer = initer;
		this.type = initer.type;
		this.w = initer.w;
		this.h = initer.h;
		this.id = RoomDesign.ID++;
		this.cells = new Array();
		this.rowStart = -1;
		this.colStart = -1;
		this.secret = initer.secret;
	}

	init(cellsCollection) {
		// Costruisce la matrice
		this.rowStart = cellsCollection[0].row;
		this.colStart = cellsCollection[0].col;
		this.build(cellsCollection);
		// Setta le uscite
		this.setExits();
	}

	build(cellsCollection) {
		this.cells = new Array();
		for (let row = 0; row < this.h; row++) {
			this.cells.push(new Array())
			for (let col = 0; col < this.w; col++) {
				this.cells[row][col] = cellsCollection[row * this.w + col];
				this.cells[row][col].rowRoom = row;
				this.cells[row][col].colRoom = col;
			}
		}
	}

	setExits() {
		if (this.type !== MazeConst.ROOM_TYPE_HALLWAY) {
			// Prende una o due uscite
			let cell = this.getOneExit();
			cell.exit = true;
			if (this.type === MazeConst.ROOM_TYPE_TWO_EXIT) {
				let otherCell = cell;
				let lCondExit = false;
				let fuse = 0;
				while (!lCondExit) {
					//let distance = this.getDistance(cell, otherCell)
					let sw = this.sameWall(cell, otherCell);
					//console.log(sw, cell, otherCell)
					if (!sw) {
						lCondExit = true;
					} else {
						otherCell = this.getOneExit();
					}
					fuse++;
					if (fuse > MazeConst.FUSE_CHOOSE_ROOM_EXIT) {
						lCondExit = true;
					}
				}
				otherCell.exit = true;
			}

			// Passa le celle e le setta visited tranne le uscite
			for (let row = 0; row < this.h; row++) {
				for (let col = 0; col < this.w; col++) {
					cell = this.cells[row][col];
					if (!cell.exit) {
						cell.visited = true;
					}

				}
			}
		}


	}

	sameWall(cell0, cell1) {
		if ((cell0.rowRoom === 0) && (cell1.rowRoom === 0)) {
			return true
		}
		if ((cell0.rowRoom === this.h - 1) && (cell1.rowRoom === this.h - 1)) {
			return true
		}
		if ((cell0.colRoom === 0) && (cell1.colRoom === 0)) {
			return true
		}
		if ((cell0.colRoom === this.w - 1) && (cell1.colRoom === this.w - 1)) {
			return true
		}

		return false;
	}

	getOneExit() {
		let corners = this.getCornersCells();
		let wallsCells = this.getCellsWithWalls();
		let chosen = new Array();
		for (let x = 0; x < wallsCells.length; x++) {
			let cell = wallsCells[x];
			if (!this.existsIn(cell, corners)) {
				chosen.push(cell);
			}
		}

		if (chosen.length == 0) {
			chosen = corners;
		}
		// Controlla che le potenziali uscite non tocchino i confini del maze
		chosen = this.removeInvalidExits(chosen);
		//console.log(chosen.length)
		if (chosen.length <= 1) {
			chosen = chosen.concat(corners);
			//console.log("-->" + chosen.length)
			chosen = this.removeInvalidExits(chosen);
		}

		return chosen[Pqp.rnd(chosen.length - 1)];
	}

	removeInvalidExits(a) {
		let ret = new Array();
		for (let x = 0; x < a.length; x++) {
			let cell = a[x];
			let lOk = true;
			if (cell.row === 0) {
				lOk = false;
			}
			if (cell.col === 0) {
				lOk = false;
			}
			if (cell.row === this.initer.mazeh - 1) {
				lOk = false;
			}
			if (cell.col === this.initer.mazew - 1) {
				lOk = false;
			}

			// 
			if (!lOk) {
				// Controlla se è angolo con un muro però valido
				let corners = this.getCornersCells();
				if (this.existsIn(cell, corners)) {
					if (((cell.row === 0) && (cell.col > 0)) || ((cell.col === 0) && (cell.row > 0)) || ((cell.row === this.initer.mazeh - 1) && (cell.col < this.initer.mazew - 1)) || ((cell.col === this.initer.mazew - 1) && (cell.row < this.initer.mazeh - 1))) {
						lOk = true
					}
				}
			}

			if (lOk) {
				ret.push(cell);
			}
		}
		return ret;
	}

	existsIn(cell, corners) {
		for (let x = 0; x < corners.length; x++) {
			if (corners[x].id == cell.id) {
				return true;
			}
		}
		return false;
	}


	getCornersCells() {
		return [this.cells[0][0], this.cells[0][this.w - 1], this.cells[this.h - 1][0], this.cells[this.h - 1][this.w - 1]];
	}

	getCellsWithWalls() {
		let ret = new Array();
		for (let row = 0; row < this.h; row++) {
			for (let col = 0; col < this.w; col++) {
				let lGet = false;
				let cell = this.cells[row][col];
				if (row == 0) {
					lGet = true;
				}
				if (row == this.h - 1) {
					lGet = true;
				}
				if (col == 0) {
					lGet = true;
				}
				if (col == this.w - 1) {
					lGet = true;
				}
				if (lGet) {
					ret.push(cell);
				}
			}
		}
		return ret;
	}

	getExits() {
		let ret = new Array();
		// per hallway dà il centro 
		if (this.type === MazeConst.ROOM_TYPE_HALLWAY) {
			let col = Math.ceil(this.w / 2);
			let row = Math.ceil(this.h / 2);
			ret.push(this.cells[row][col]);
		} else {
			for (let row = 0; row < this.h; row++) {
				for (let col = 0; col < this.w; col++) {
					let cell = this.cells[row][col];
					if (cell.exit) {
						ret.push(cell);
					}
				}
			}
		}
		return ret;
	}

	static setRoomIniterDimensions(roomIniter) {
		if ((Pqp.isNullOrEmpty(roomIniter.w)) || (Pqp.isNullOrEmpty(roomIniter.h))) {
			let dims = RoomDesign["SIZES_" + roomIniter.size];
			let dim = dims[Pqp.rnd(dims.length - 1)];
			let w, h
			if (Pqp.rnd(1) === 0) {
				w = dim[0];
				h = dim[1];
			} else {
				w = dim[1];
				h = dim[0];
			}
			roomIniter.w = w;
			roomIniter.h = h;
		}
		//console.log(roomIniter.h,roomIniter.w)

	}

}

RoomDesign.ID = 0;

/*MazeConst.ROOM_SIZE_SMALL = "SMALL";
MazeConst.ROOM_SIZE_MEDIUM = "MEDIUM";
MazeConst.ROOM_SIZE_LARGE = "LARGE";*/

RoomDesign.SIZES_SMALL = [[2, 2], [3, 2]];
RoomDesign.SIZES_MEDIUM = [[3, 3], [4, 2]];
RoomDesign.SIZES_LARGE = [[4, 3], [4, 4]];

/*MazeConst.ROOM_TYPE_HALLWAY = "typeHallway";
MazeConst.ROOM_TYPE_ONE_EXIT = "typeOneExit";
MazeConst.ROOM_TYPE_TWO_EXIT = "typeTwoExit";*/